module.exports = __webpack_public_path__ + "static/CookieRun-Regular.subset-d4c3848db0da6c9ab2e8290da5bab919.woff2";